import src from "IMAGE";
export default { src, width: 296, height: 30, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AIaWDNeFlQzRhZUMyY6fDOmGlwzag5MM0nyMDNB2hAzBBOIPquKdwpoAAAAASUVORK5CYII="};
